
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { LocationDetailDto_$reflection, LocationCountry_$reflection, Location_$reflection, LocationCreateOrUpdateDto_$reflection } from "../../Shared/Location.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, AccountSettings_$reflection, LocationId_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { union_type, class_type, anonRecord_type, string_type, record_type, list_type, option_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { BusinessUnitOverviewDto_$reflection } from "../../Shared/BusinessUnit.js";

export class State extends Record {
    constructor(Form, LocationId, BusinessUnits, Locations, AccountSettings, FormState) {
        super();
        this.Form = Form;
        this.LocationId = LocationId;
        this.BusinessUnits = BusinessUnits;
        this.Locations = Locations;
        this.AccountSettings = AccountSettings;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Location.Form.Types.State", [], State, () => [["Form", RequestedValue$1_$reflection(LocationCreateOrUpdateDto_$reflection())], ["LocationId", option_type(LocationId_$reflection())], ["BusinessUnits", RequestedValue$1_$reflection(list_type(BusinessUnitOverviewDto_$reflection()))], ["Locations", RequestedValue$1_$reflection(list_type(Location_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetName", "SetDescription", "SetStreet", "SetAddressSupplement", "SetZipCode", "SetCity", "SetCountry", "SetBusinessUnit", "SetParentLocation", "CreateLocation", "UpdateLocation", "LocationFetched", "LocationCreated", "LocationUpdated", "FetchError", "SaveError", "AccountSettingsFetched", "BusinessUnitsFetched", "LocationsFetched"];
    }
}

export function Msg_$reflection() {
    return union_type("Location.Form.Types.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", LocationCountry_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", BusinessUnitOverviewDto_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Location_$reflection()]))]], [], [], [["Item", LocationDetailDto_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]], [["Item", AccountSettings_$reflection()]], [["Item", list_type(BusinessUnitOverviewDto_$reflection())]], [["Item", list_type(Location_$reflection())]]]);
}

